// Site managed host (N per site). Mirrors backend HostFields/HostCreateIn/
// HostUpdateIn/HostOut in api/v1/site_hosts.py. slug is immutable (create-only).

export type HostRole = "homeassistant_primary" | "frigate_primary" | "edge_gateway" | "generic";
export type AnsibleConnection = "ssh" | "paramiko_ssh" | "local";

export interface HostFields {
  fqdn?: string | null;
  display_name?: string | null;
  role?: HostRole | null;
  ansible_host?: string | null;
  ansible_user?: string | null;
  ansible_port?: number | null;
  ansible_connection?: AnsibleConnection | null;
  proxy_jump_host?: string | null;
  connection_secret_ref?: string | null;
  become_secret_ref?: string | null;
  break_glass_secret_ref?: string | null;
  address?: string | null;
  gateway?: string | null;
  dns_servers?: string[];
  vlan_name?: string | null;
  mgmt_vlan_enabled?: boolean;
  switch_port?: number | null;
  site_profile?: string | null;
  switch_profile?: string | null;
  controller_profile?: string | null;
  homeassistant_enabled?: boolean;
  frigate_enabled?: boolean;
  mosquitto_enabled?: boolean;
  go2rtc_enabled?: boolean;
  solar_enabled?: boolean;
  custom_services?: string[];
  notes?: string[];
  vendor_extras?: Record<string, unknown>;
}
export interface HostCreateIn extends HostFields {
  slug: string;
}
export type HostUpdateIn = HostFields;
export interface HostConfig extends HostFields {
  id: string;
  site_id: string;
  slug: string;
}

export const HOST_ROLES: ReadonlyArray<{ value: HostRole; label: string }> = [
  { value: "homeassistant_primary", label: "Home Assistant primary" },
  { value: "frigate_primary", label: "Frigate primary" },
  { value: "edge_gateway", label: "Edge gateway" },
  { value: "generic", label: "Generic" },
];
export const ANSIBLE_CONNECTIONS: ReadonlyArray<{ value: AnsibleConnection; label: string }> = [
  { value: "ssh", label: "ssh" },
  { value: "paramiko_ssh", label: "paramiko_ssh" },
  { value: "local", label: "local" },
];
